module.exports = __webpack_public_path__ + "media/property-types/Cottage_Alone-0e9ff8fe.png";